// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeEnrollmentApi = class EdgeEnrollmentApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param enrollmentRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async clientEnrollmentCreateEnrollment(enrollmentRequest, xProgramId) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/createEnrollment';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enrollmentRequest' is not null or undefined
        if (enrollmentRequest === null || enrollmentRequest === undefined) {
            throw new Error('Required parameter enrollmentRequest was null or undefined when calling clientEnrollmentCreateEnrollment.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentRequest, "EnrollmentRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param deactivateEnrollmentRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async clientEnrollmentDeactivateEnrollment(deactivateEnrollmentRequest, xProgramId) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/deactivateEnrollment';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'deactivateEnrollmentRequest' is not null or undefined
        if (deactivateEnrollmentRequest === null || deactivateEnrollmentRequest === undefined) {
            throw new Error('Required parameter deactivateEnrollmentRequest was null or undefined when calling clientEnrollmentDeactivateEnrollment.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(deactivateEnrollmentRequest, "DeactivateEnrollmentRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentDeactivateResponse");
        }
        return response;
    }
    /**
     *
     * @param accountId
     * @param xProgramId The program id from the list of allowed program ids
     */
    async clientEnrollmentGetEnrollmentByAccountId(accountId, xProgramId) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/getEnrollmentByAccountId/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling clientEnrollmentGetEnrollmentByAccountId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param memberNumber
     * @param xProgramId The program id from the list of allowed program ids
     */
    async clientEnrollmentGetEnrollmentByMemberNumber(memberNumber, xProgramId) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/getEnrollmentByMemberNumber/{memberNumber}'
            .replace('{' + 'memberNumber' + '}', encodeURIComponent(String(memberNumber)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'memberNumber' is not null or undefined
        if (memberNumber === null || memberNumber === undefined) {
            throw new Error('Required parameter memberNumber was null or undefined when calling clientEnrollmentGetEnrollmentByMemberNumber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param accountId
     * @param enrollmentRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async clientEnrollmentUpdateEnrollment(accountId, enrollmentRequest, xProgramId) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/updateEnrollment/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling clientEnrollmentUpdateEnrollment.');
        }
        // verify required parameter 'enrollmentRequest' is not null or undefined
        if (enrollmentRequest === null || enrollmentRequest === undefined) {
            throw new Error('Required parameter enrollmentRequest was null or undefined when calling clientEnrollmentUpdateEnrollment.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentRequest, "EnrollmentRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param enrollmentIsValidMemberNumberRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollmentCheckMemberNumber(enrollmentIsValidMemberNumberRequestModel, xProgramId) {
        const _url_ = '/edge/enrollment/CheckMemberNumber';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enrollmentIsValidMemberNumberRequestModel' is not null or undefined
        if (enrollmentIsValidMemberNumberRequestModel === null || enrollmentIsValidMemberNumberRequestModel === undefined) {
            throw new Error('Required parameter enrollmentIsValidMemberNumberRequestModel was null or undefined when calling enrollmentCheckMemberNumber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentIsValidMemberNumberRequestModel, "EnrollmentIsValidMemberNumberRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentCheckMemberNumberDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param enrollPatientRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollmentEnrollPatient(enrollPatientRequestModel, xProgramId) {
        const _url_ = '/edge/enrollment/EnrollPatient';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enrollPatientRequestModel' is not null or undefined
        if (enrollPatientRequestModel === null || enrollPatientRequestModel === undefined) {
            throw new Error('Required parameter enrollPatientRequestModel was null or undefined when calling enrollmentEnrollPatient.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollPatientRequestModel, "EnrollPatientRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentEnrollPatientDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param getBestEnrollmentRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollmentGetBestEnrollment(getBestEnrollmentRequest, xProgramId) {
        const _url_ = '/edge/enrollment/getBestEnrollment';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getBestEnrollmentRequest' is not null or undefined
        if (getBestEnrollmentRequest === null || getBestEnrollmentRequest === undefined) {
            throw new Error('Required parameter getBestEnrollmentRequest was null or undefined when calling enrollmentGetBestEnrollment.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getBestEnrollmentRequest, "GetBestEnrollmentRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "GetBestEnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param getBestEnrollmentRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollmentGetBestEnrollment_1(getBestEnrollmentRequest, xProgramId) {
        const _url_ = '/edge/enrollment/GetBestEnrollment';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getBestEnrollmentRequest' is not null or undefined
        if (getBestEnrollmentRequest === null || getBestEnrollmentRequest === undefined) {
            throw new Error('Required parameter getBestEnrollmentRequest was null or undefined when calling enrollmentGetBestEnrollment_1.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getBestEnrollmentRequest, "GetBestEnrollmentRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentGetBestEnrollmentDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param getBestEnrollmentV2RequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollmentGetBestEnrollmentsV2(getBestEnrollmentV2RequestModel, xProgramId) {
        const _url_ = '/edge/enrollment/GetBestEnrollmentsV2';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getBestEnrollmentV2RequestModel' is not null or undefined
        if (getBestEnrollmentV2RequestModel === null || getBestEnrollmentV2RequestModel === undefined) {
            throw new Error('Required parameter getBestEnrollmentV2RequestModel was null or undefined when calling enrollmentGetBestEnrollmentsV2.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getBestEnrollmentV2RequestModel, "GetBestEnrollmentV2RequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentGetBestEnrollmentsV2DefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param enrollmentWithEmailSignaturePdfRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientEnrollmentEnrollmentWithEmailSignaturePdfRequest(enrollmentWithEmailSignaturePdfRequest, xProgramId) {
        const _url_ = '/edge/enrollment/v2/patient/enrollmentWithEmailSignaturePdfRequest';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enrollmentWithEmailSignaturePdfRequest' is not null or undefined
        if (enrollmentWithEmailSignaturePdfRequest === null || enrollmentWithEmailSignaturePdfRequest === undefined) {
            throw new Error('Required parameter enrollmentWithEmailSignaturePdfRequest was null or undefined when calling patientEnrollmentEnrollmentWithEmailSignaturePdfRequest.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentWithEmailSignaturePdfRequest, "EnrollmentWithEmailSignaturePdfRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientEnrollmentControllerEnrollmentWithEmailSignaturePdfRequestResponse");
        }
        return response;
    }
    /**
     *
     * @param enrollmentWithEmailSignatureTemplateRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientEnrollmentEnrollmentWithEmailSignatureTemplateRequest(enrollmentWithEmailSignatureTemplateRequest, xProgramId) {
        const _url_ = '/edge/enrollment/v2/patient/enrollmentWithEmailSignatureTemplateRequest';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enrollmentWithEmailSignatureTemplateRequest' is not null or undefined
        if (enrollmentWithEmailSignatureTemplateRequest === null || enrollmentWithEmailSignatureTemplateRequest === undefined) {
            throw new Error('Required parameter enrollmentWithEmailSignatureTemplateRequest was null or undefined when calling patientEnrollmentEnrollmentWithEmailSignatureTemplateRequest.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentWithEmailSignatureTemplateRequest, "EnrollmentWithEmailSignatureTemplateRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientEnrollmentControllerEnrollmentWithEmailSignatureTemplateRequestResponse");
        }
        return response;
    }
    /**
     *
     * @param enrollmentWithSignatureUpload default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientEnrollmentEnrollmentWithSignatureDocumentUpload(enrollmentWithSignatureUpload, xProgramId) {
        const _url_ = '/edge/enrollment/v2/patient/enrollmentWithSignatureDocumentUpload';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enrollmentWithSignatureUpload' is not null or undefined
        if (enrollmentWithSignatureUpload === null || enrollmentWithSignatureUpload === undefined) {
            throw new Error('Required parameter enrollmentWithSignatureUpload was null or undefined when calling patientEnrollmentEnrollmentWithSignatureDocumentUpload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentWithSignatureUpload, "EnrollmentWithSignatureUpload"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientEnrollmentControllerEnrollmentWithSignatureDocumentUploadResponse");
        }
        return response;
    }
    /**
     *
     * @param xProgramId The program id from the list of allowed program ids
     */
    async paymentPaymentMethod(xProgramId) {
        const _url_ = '/edge/enrollment/Payment/PaymentMethod';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentPaymentPaymentMethodPaymentMethodResponse");
        }
        return response;
    }
};
EdgeEnrollmentApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeEnrollmentApi);
export { EdgeEnrollmentApi };
//# sourceMappingURL=edgeEnrollmentApi.js.map